<template>
	<div class="box display-flex flex-wrap flex-column" role="button" @click="$emit('click')">
		<div class="top background" :style="{ 'background-image': `url(${backgroundUrl})` }" />
		<div class="bottom flex-1 flex-centerize">
			<slot name="text" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'HelpBox',
	props: { backgroundUrl: { type: String } },
};
</script>

<style lang="scss" scoped>
.box {
	border: 1px solid var(--tertiary-border-color);
	border-radius: 10px 10px 12px 12px;
	background: #f9fafc;
	&:hover {
		box-shadow: 0px 2px 10px #00000053;
		border-color: #5858e4;
		.bottom {
			border-color: #5858e4;
		}
	}
	.top {
		height: 164px;
		&.background {
			background-size: cover;
			margin: 7px;
		}
	}
	.bottom {
		background: #5858e4;
		border-radius: 0px 0px 10px 10px;
		color: #ffffff;
		font-weight: 200;
	}
}
</style>
